import { render } from "./tipButton.vue?vue&type=template&id=80342542&scoped=true"
import script from "./tipButton.vue?vue&type=script&lang=js"
export * from "./tipButton.vue?vue&type=script&lang=js"

import "./tipButton.vue?vue&type=style&index=0&id=80342542&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-80342542"

export default script